// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3pARD","title":"Info_title__3dieb","links":"Info_links__2Nqhq","link":"Info_link__1-Yxs","logo":"Info_logo__v33C4"};